// extracted by mini-css-extract-plugin
export var postsGrid = "PostListContentful-module--postsGrid--xNO9x";
export var large = "PostListContentful-module--large--RVlso";
export var postsList = "PostListContentful-module--postsList--ot3f0";